import React from "react";
import "./baseStyles.css";

const ContactPage = () => (
  <div className="legal-container">
    <h1>Contact Us</h1>
    <p>If you have questions, suggestions, or need assistance, we're here to help.</p>

    <h2>Support Email</h2>
    <p>
      📧{" "}
      <a href="mailto:support@mydailyreminders.com">
        support@mydailyreminders.com
      </a>
    </p>

    <h2>Business Info</h2>
    <p>MyDailyReminders, LLC</p>
    <p>Abita Springs, LA</p>

    <h2>Response Time</h2>
    <p>We typically respond to inquiries within 1–2 business days.</p>
  </div>
);

export default ContactPage;
